import { render, staticRenderFns } from "./guideTemp.vue?vue&type=template&id=5ba8da6a&scoped=true&"
import script from "./guideTemp.vue?vue&type=script&lang=js&"
export * from "./guideTemp.vue?vue&type=script&lang=js&"
import style0 from "./guideTemp.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./guideTemp.vue?vue&type=style&index=1&id=5ba8da6a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ba8da6a",
  null
  
)

component.options.__file = "guideTemp.vue"
export default component.exports